import { render, staticRenderFns } from "./ChatEditor.vue?vue&type=template&id=4d09c6f0&scoped=true&"
import script from "./ChatEditor.vue?vue&type=script&lang=js&"
export * from "./ChatEditor.vue?vue&type=script&lang=js&"
import style0 from "./ChatEditor.vue?vue&type=style&index=0&id=4d09c6f0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d09c6f0",
  null
  
)

export default component.exports